import { SecondaryButton } from "@graffer-inc/console-design-kit";
import React from "react";
import { useHistory } from "react-router-dom";

import { ServiceProviderR } from "../../../pages/service-provider/routes";

export const NavigationMenu: React.FC<{ orgId: string }> = ({ orgId }) => {
  const history = useHistory();

  return (
    <div className="columns">
      <div className="column has-text-right buttons">
        <SecondaryButton
          text="場所マスタ表示"
          onClick={() => {
            history.push(
              ServiceProviderR.ProcManagementPlacesList.link({ orgId }),
            );
          }}
        />
      </div>
    </div>
  );
};

export default NavigationMenu;
